import { Notification, type NotificationProps } from "./Notification";

import { values } from "@/utils/object";
import { useEffect, useRef } from "react";
import { CLASS_CONSTANTS } from "@/utils/constants";
import { scrollToRef } from "@/utils/scrollToRef";
import clsx from "clsx";
import { css } from "@linaria/core";

const notificationWrapClassName = css`
  padding: 0 !important;
  margin: 0 0 15px !important;
  list-style: none !important;
  display: flex;
  flex-direction: column;
  gap: var(--ws-notification-gap, 1rem);
  &:empty {
    margin-bottom: 0 !important;
  }
`;

export interface NotificationListProps {
  items: NotificationProps["item"][];
  onClose?: (index: number) => void;
  className?: string;
  shouldScrollToRef?: boolean;
}

export const NotificationList: React.FC<NotificationListProps> = ({
  items,
  className,
  shouldScrollToRef = false,
  onClose,
  ...props
}) => {
  const notificationsRef = useRef<HTMLUListElement>(null);

  items = items || [];
  useEffect(() => {
    if (!shouldScrollToRef) return;
    if (items.length) {
      scrollToRef(notificationsRef, (el) => {
        if (el.closest(".ws-modal-content")) return 0;
        return el.getBoundingClientRect().y;
      });
    }
  }, [items, shouldScrollToRef]);

  if (items.length <= 0) {
    return null;
  }

  return (
    <ul
      ref={notificationsRef}
      {...props}
      className={clsx(
        className,
        CLASS_CONSTANTS.NOTIFICATION.CONTAINER,
        notificationWrapClassName,
      )}
    >
      {values(items).map((item, i) => (
        <Notification
          key={"notification" + i}
          index={i}
          item={item}
          onClose={onClose}
        />
      ))}
    </ul>
  );
};
